import { Pipe, PipeTransform } from '@angular/core';
import { TOOTH_POSITIONS_WITH_FG } from '../../perio-exam-screen/services/perio-exam/models';

@Pipe({
  name: 'hasFg',
  pure: true,
  standalone: true,
})
export class HasFgPipe implements PipeTransform {
  public transform(value: number): boolean {
    return TOOTH_POSITIONS_WITH_FG.includes(value);
  }
}
